import React from 'react'

export const Toast = ({ type = 'info', message, exiting }) => {
  const variants = {
    success: "bg-sky-50 border border-sky-200 text-sky-900",
    error: "bg-red-50 border border-red-200 text-red-900",
    warning: "bg-yellow-50 border border-yellow-200 text-yellow-800",
    info: "bg-white border border-slate-200 text-slate-900",
  }
  return (
    <div className={`fixed top-6 left-1/2 -translate-x-1/2 px-5 py-3 rounded-xl shadow-lg text-sm font-medium z-50 ${exiting ? 'animate-toast-out' : 'animate-toast-in'} ${variants[type]}`}>
      {message}
    </div>
  )
}
